import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'mapfre-auditlib';

@Injectable({
  providedIn: 'root'
})
export class ExportConfigService {

  className = 'ExportConfigService'
  constructor(private http: HttpClient, private translateService: TranslateService, private cacheService: CacheService) { }

  getExportConfig() {
    return this.http.get("./assets/mocks/EXPORT_CONFIG.json").pipe(map<any[], any[]>(res => res['export-config']));
  }

  getExportConfigByCategory(category) {
    return this.getExportConfig().pipe(map<any[], any>(res => res[0][category]));
  }

  getAllCategories() {
    return this.getExportConfig().pipe(map<any[], any>(res => {
      return _.map(res[0], function (value, key) {
        return { 'text': key };
      });
    }));
  }

  getConfigExportElement(name) {
    return this.getExportConfig().pipe(map<any[], any>(res => {// mejora previsto no previsto
      let objecRes = _.cloneDeep(res);
      const structure = _.reduce(_.filter(_.map(objecRes[0][name],(value, key) => {
        if (_.isArray(value)) {
          const importables = [];
          _.forEach(value, it => {
            if (it['is_exportable']) {
              importables.push(it);
            }
          })
          return { [key]: importables };
        }
        else {
          if (value['is_exportable']) {
            return { [key]: value }
          }
        }

      }), it => it),(prev,next)=>_.assign(prev,next));
      _.forEach(_.keysIn(structure), (key: any) => {
        if (!_.isArray(structure[key])) {
          structure[key]['column'] = this.translateService.instant(structure[key]['column']);
        }
        else {
          _.forEach(structure[key], elem => {
            elem['column'] = this.translateService.instant(elem['column']);
          })
        }
      });
      return structure;
    }))
  }

  getConfigImportElement(name) {
    return this.getExportConfig().pipe(map<any[], any>(res => {
      let objecRes = _.cloneDeep(res);
      const structure: any = _.reduce(_.filter(_.map(objecRes[0][name], (value, key) => {
        if (_.isArray(value)) {
          const importables = [];
          _.forEach(value, it => {
            if (it['is_importable']) {
              importables.push(it);
            }
          })
          return { [key]: importables };
        }
        else {
          if (value['is_importable']) {
            return { [key]: value }
          }
        }

      }), it => it),(prev,next)=> _.assign(prev,next));
      _.forEach(_.keysIn(structure), (key: any) => {
        if (!_.isArray(structure[key])) {
          structure[key]['column'] = this.translateService.instant(structure[key]['column']);
        }
        else {
          _.forEach(structure[key], elem => {
            elem['column'] = this.translateService.instant(elem['column']);
          })
        }
      });
      return structure;
    }))
  }

  removeById(array) {
    array.forEach(element => {
      delete element.id;
    });
    return array;
  }

  getFiltersMappingFile() {
    return this.http.get('./assets/mocks/FILTERS_MAPPING.json');
  }

  getFiltersStructure(key) {
    return Observable.create((observer) => {
      this.getFiltersMappingFile().subscribe((data) => {
        observer.next(data[key]);
        observer.complete();
      });
    });

  }

  setFiltersConfig(data): Observable<any[]> {
    let key = "filtersConfigCache" + "_" + data.type;
    this.cacheService.deleteCache(key);
    return this.http.post<any[]>(environment.base_URL + "/user-config", data);
  }

  getFiltersConfig(type) {
    const params = {
      type
    }
    return this.http.get(environment.base_URL + "/user-config", { params });
  }

  getFiltersConfigCache(type, cache = true, cacheKey = "filtersConfigCache"): any{
    const params = {
      type
    }
    if (cache && this.cacheService.canUseCache(cacheKey, [type.toString()])) {
      return this.cacheService.getCacheData(cacheKey, [type.toString()]);
    } else {
      let observable = this.http.get(environment.base_URL + "/user-config", { params }).pipe(
        map(res => {
            this.cacheService.updateCacheData(res, cacheKey, [type.toString()])
            return res
        })
      );
      this.cacheService.updateCacheReq(cacheKey, [type.toString()]);
      return observable;
      }
    }

  getTaskTemplate() {
    return this.http.get('./assets/templates/taskTemplate.html', { responseType: 'text' }).pipe(map(res => res.toString()));
  }

  getFactObservedTemplate() {
    return this.http.get('./assets/templates/factObservedTemplate.html', { responseType: 'text' }).pipe(map(res => res.toString()));
  }

  getAdittionalProposalTemplate() {
    return this.http.get('./assets/templates/additionalProposalTemplate.html', { responseType: 'text' }).pipe(map(res => res.toString()));
  }

  getRecommendationTemplate() {
    return this.http.get('./assets/templates/recommendationTemplate.html', { responseType: 'text' }).pipe(map(res => res.toString()));
  }


}